// Logica pura do AgendarRelatorioDialog, sem React, para testar com jest.
// Formula de data (igual ao back, FormulaDataAgendamento): <valor>;<modificador>;<periodo>
//   valor: $data_atual | $inicio_mes | $final_mes ; periodo: $dia | $mes | $ano

export const VALORES = ['$data_atual', '$inicio_mes', '$final_mes']
export const PERIODOS = ['$dia', '$mes', '$ano']

export const LINHA_PADRAO = { usarFormula: false, valor: '$inicio_mes', modificador: 0, periodo: '$mes' }

export const isFormula = (valor) => typeof valor === 'string' && valor.trim().startsWith('$')

/** Data local em yyyy-MM-dd (sem toISOString, que converte para UTC e pode voltar um dia). */
export const formatarDataIso = (data) => {
  if (!data) {
    return null
  }
  if (typeof data === 'string') {
    return /^\d{4}-\d{2}-\d{2}/.test(data) ? data.substring(0, 10) : null
  }
  if (!(data instanceof Date) || isNaN(data.getTime())) {
    return null
  }
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const dia = String(data.getDate()).padStart(2, '0')
  return `${data.getFullYear()}-${mes}-${dia}`
}

/** yyyy-MM-dd -> dd/MM/yyyy, para exibir. */
export const formatarDataBr = (iso) => {
  if (!iso || iso.length < 10) {
    return ''
  }
  return `${iso.substring(8, 10)}/${iso.substring(5, 7)}/${iso.substring(0, 4)}`
}

export const montarFormula = (linha) => `${linha.valor};${Number(linha.modificador) || 0};${linha.periodo}`

/** Formula gravada -> linha da grade; null se nao for uma formula reconhecida. */
export const lerFormula = (formula) => {
  if (!isFormula(formula)) {
    return null
  }
  const partes = formula.split(';').map((p) => p.trim().toLowerCase())
  if (partes.length !== 3 || !VALORES.includes(partes[0]) || !PERIODOS.includes(partes[2])) {
    return null
  }
  const modificador = parseInt(partes[1], 10)
  if (isNaN(modificador)) {
    return null
  }
  return { usarFormula: true, valor: partes[0], modificador, periodo: partes[2] }
}

/** Linhas iniciais da grade: do agendamento salvo (edicao) ou padrao, sem formula. */
export const linhasIniciais = (camposData, filtrosSalvos) => {
  const linhas = {}
  camposData.forEach(({ campo }) => {
    const salva = filtrosSalvos ? lerFormula(filtrosSalvos[campo]) : null
    linhas[campo] = salva || { ...LINHA_PADRAO }
  })
  return linhas
}

/**
 * Filtros do agendamento (objeto que vira o JSON de agendamento_relatorio.filtros):
 * - campos que nao sao data: como estao nos filtros da tela;
 * - data com formula marcada: a formula;
 * - data sem formula: a data da tela em yyyy-MM-dd; sem data, o campo nao vai (D4).
 */
export const montarFiltros = (filtrosTela, camposData, linhas) => {
  const filtros = { ...(filtrosTela || {}) }
  camposData.forEach(({ campo }) => {
    const linha = linhas[campo]
    if (linha && linha.usarFormula) {
      filtros[campo] = montarFormula(linha)
      return
    }
    const fixa = formatarDataIso(filtros[campo])
    if (fixa) {
      filtros[campo] = fixa
    } else {
      delete filtros[campo]
    }
  })
  return filtros
}

/** Filtros salvos (JSON) -> objeto; {} se vazio ou invalido. */
export const lerFiltros = (json) => {
  if (!json) {
    return {}
  }
  try {
    const filtros = JSON.parse(json)
    return filtros && typeof filtros === 'object' ? filtros : {}
  } catch (e) {
    return {}
  }
}

/** Mensagem do back (400 com texto) ou generica. */
export const mensagemDeErro = (erro, padrao) => {
  const dados = erro && erro.response && erro.response.data
  if (typeof dados === 'string' && dados.trim()) {
    return dados
  }
  return padrao
}

/**
 * Pode agendar = acesso (listar) ao menu "Relatorios agendados" (D7 revista em 01/10 com o stakeholder: a listagem
 * nao tem "Novo", o agendamento nasce no botao Agendar de cada relatorio). Mesma regra do resto do sistema
 * (utils.getMenusValidos/checkPermissoesMenu): menu ausente da arvore = nao pode (o back nao manda menu sem
 * permissao de listar); sem permissao no item vale a do menu pai; sem permissao na cadeia toda = liberado.
 */
export const podeAgendar = (menus, caminho, permissoesPai = null) => {
  if (!Array.isArray(menus)) {
    return false
  }
  for (const menu of menus) {
    const permissoes = Array.isArray(menu.permissoes) && menu.permissoes.length > 0 ? menu.permissoes[0] : permissoesPai
    if (menu.caminho === caminho) {
      return !permissoes || Boolean(permissoes.listar)
    }
    if (podeAgendar(menu.items, caminho, permissoes)) {
      return true
    }
  }
  return false
}

/**
 * Usuario de unidade unica (storage.getUsuarioUnidadeUnica; a unidade dele e a storage.getUnit): o filtro de unidades
 * so pode ser ela. Nao vale para a unidade escolhida no topo da tela, que qualquer usuario troca: travar por ela
 * sobrescreveria as unidades salvas de quem so editou o e-mail. null = nao trava.
 */
export const unidadesTravadas = (usuarioUnidadeUnica, unidadeUsuario) =>
  usuarioUnidadeUnica && unidadeUsuario && unidadeUsuario.oid
    ? [{ id: unidadeUsuario.oid, value: unidadeUsuario.sigla }]
    : null

/**
 * "Ver relatorio": a aba abre em branco no clique (gesto do usuario) e recebe o endereco quando o back responder.
 * Aberta so depois da resposta, o navegador a trata como pop-up e bloqueia sem aviso.
 */
export const abrirAbaEmBranco = () => window.open('', '_blank')

export const mostrarNaAba = (janela, url) => {
  if (janela && !janela.closed) {
    janela.location.href = url
    janela.focus()
  } else {
    window.open(url, '_blank')
  }
}

export const fecharAba = (janela) => {
  if (janela && !janela.closed) {
    janela.close()
  }
}
